const DEBUG = true
export const CALL_DB_PATH = DEBUG ? 'dev_calls' : 'prod_calls'
export const COMPANY_DB_PATH = DEBUG ? 'dev_companies' : 'prod_companies'
export const EMPLOYEE_DB_PATH = DEBUG ? 'dev_employees' : 'prod_employees'